<template>
    <validation-provider :rules="rules" :name="name" v-slot="{errors, required}" >
        <v-text-field v-bind="$attrs" v-on="$listeners" :error-messages="errors"
        :color="color">
            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
            <template v-for="(_, name) of $scopedSlots" v-slot:[name]="scope">
                <slot :name="name" v-bind="scope"/>
            </template>

            <template #label v-if="label">
                <div :class="[errors.length==0 ? `${color}--text` : '']">
                    {{getLabel(required)}}
                </div>
            </template>
        </v-text-field>
    </validation-provider>
</template>
<script>
export default {
    name:"TextField",
    props:{
        rules: {
            type: [Object, String],
            default: ""
        },
        label: {
            type: String
        },
        color:{
            type: String,
            default: "primary"
        },
        name:{
            type: String,
        }
    },
    methods:{
        getLabel(required){
            if(this.label){
                if (required){
                    return this.label + " *";
                }
                return this.label;
            }
            return undefined;
        }
    },
}
</script>